import { cn } from '@/lib/utils'
import type { ReactNode } from 'react'

export function SectionLabel(props: { children?: ReactNode; className?: string }) {
  return (
    <span
      data-slot="section-label"
      className={cn('text-muted-foreground py-1.5 text-[10px] font-semibold tracking-wider uppercase', props.className)}
    >
      {props.children}
    </span>
  )
}
